import { APM } from "../../../interceptors/base-axios/base-axios";
import { ITableColumnHeader } from "../../../ui/building-blocks/DSSFramework";

export const ROUTER_PATHS = {
    Track_Downloads: "track-downloads",
    Track_Downloads_Search: "downloadtracking",
    Download_Tracking: "/userlogin/user-care/downloadtracking",
    trackDownloadBack: "/userlogin/user-care/track-downloads",
    Guest_Account: "guest-account-management",
    Contact_Administration: "contact-adminstration",
    Add_User: "contact-add-user",
    Add_Contact_User: "/userlogin/user-care/contact-add-user",
    Edit_User: "contact-edit-user",
    Edit_Contact_User: "/userlogin/user-care/contact-edit-user",
    USER_CARE:"/userlogin/user-care",
    Operator_Admin:"operator-admin",
    Inds_Share:"inds-share",
    BROADCAST_PROMOTIONS: "broadcast-promotions",
    Reports:{
      reports:"reports",
     
    }

}
export const INDS_StoreFrontId = 2;
export const Start =0;
export const Length =200000;
export const customerPid=41960182;
export const subscriptionStatus= "New"
export const columnHeader = [
    { id: 'sCustomerName', label: 'Customer Name' },
    { id: 'sUserID', label: 'Contact' },
    { id: 'sFileName', label: 'File Name' },
    { id: 'sNavDbName', label: 'NavDB' },
    { id: 'sDownloadDateTime', label: 'Downloaded On' }
];
export const sourceOptions = [
    { label: 'INDS', value: 'INDS' },
    { label: 'IDM', value: 'IDM' }
];

export const statusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' }
];

export const roleOptions = [
  { label: 'Customer', value: 'customer' },
  { label: 'Customer Support', value: 'customer_support' },
  { label: 'Account Rep', value: 'account_rep' },
  { label: 'Admin', value: 'admin' },
  { label: 'Operator Admin', value: 'operator_admin' }
];

export const contactAdministrationSearchOptions = [
  { label: 'Full Name', value: 'fullName' },
  { label: 'Company', value: 'companyName' },
  { label: 'Email ID', value: 'honeywellId' },
  { label: 'Honeywell ID', value: 'honeywellUID' },
  { label: 'Customer Number', value: 'customerNameLabel' },
  { label: 'Tail Number', value: 'tailNumber' },
  { label: 'Serial Number', value: 'serialNumber' }
];

export const editContactTableColumnHeader: ITableColumnHeader[] = [
  { id: 'bomType', label: 'BOM TYPE' },
  { id: 'erpcodes', label: 'PRODUCTS' },
  { id: 'serialNumber', label: 'A/C S/N' },
  { id: 'tailNumber', label: 'A/C T/N' },
  { id: 'aircraftMake', label: 'A/C TYPE' },
  { id: 'expiredDate', label: 'EXPIRY DATE' },
  { id: 'deliveryType', label: 'DELIVERY' }
];

export enum FileValidFormats {
  XLSX = '.xlsx',
  XLS = '.xls',
  CSV = '.csv',
  DOC = '.doc',
  DOCX = '.docx',
  PDF = '.pdf',
}

export const MIME_TYPES = {
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS: 'application/vnd.ms-excel',
  CSV: 'text/csv',
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};

const getMaxUploadSize = (): number => {
  const envSize = (window as any).ENV?.MAX_FILE_UPLOAD_SIZE_MB;
  return envSize ? envSize * 1024 * 1024 : 25 * 1024 * 1024;
};
export const MSG_Upload_File_Validation =
  `Total upload size cannot exceed ${getMaxUploadSize() / (1024 * 1024)}MB.`;

const normalizeFileType = (type: string): string => {
  return type.trim().toLowerCase();
};

const getFormatMap = (): Record<string, string> => ({
  xlsx: MIME_TYPES.XLSX,
  xls: MIME_TYPES.XLS,
  csv: MIME_TYPES.CSV,
  pdf: MIME_TYPES.PDF,
  doc: MIME_TYPES.DOC,
  docx: MIME_TYPES.DOCX,
});


const getAllowedFileTypes = () => {
  const envTypes = (window as any).ENV?.ALLOWED_FILE_TYPES;
  if (envTypes) {
    const types = envTypes.split(',').map(normalizeFileType);
    const result: Record<string, string[]> = {};
    const formatMap = getFormatMap();
    
    types.forEach((type: string) => {
      const mimeType = formatMap[type];
      if (mimeType) {
        result[mimeType] = [`.${type}`];
      }
    });
    return result;
  }
  const formatMap = getFormatMap();
  return {
    [formatMap.xls]: [FileValidFormats.XLS],
    [formatMap.xlsx]: [FileValidFormats.XLSX],
    [formatMap.pdf]: [FileValidFormats.PDF],
    [formatMap.doc]: [FileValidFormats.DOC],
    [formatMap.docx]: [FileValidFormats.DOCX],
  };
};

const getAllowedFileTypesList = (): string[] => {
  const envTypes = (window as any).ENV?.ALLOWED_FILE_TYPES;
  if (envTypes) {
    const types = envTypes.split(',').map(normalizeFileType);
    const formatMap = getFormatMap();
    return types.map((type: string) => formatMap[type]).filter(Boolean);
  }
  const formatMap = getFormatMap();
  return [
    formatMap.xls,
    formatMap.xlsx,
    formatMap.pdf,
    formatMap.doc,
    formatMap.docx,
  ];
};

export const ALLOWED_FILE_TYPES_FOR_UPLOAD = getAllowedFileTypes();
export const ALLOWED_FILE_TYPES_LIST = getAllowedFileTypesList();
export const MAX_FILE_UPLOAD_SIZE = getMaxUploadSize();
